export const CONTENT_TOOL_HOSTS: EnvironmentMetaData[] = [
    { host: 'https://content-tool.storymagic.co' },
    { host: 'https://content-tool-dev.storymagic.co' },
    { host: 'https://content-tool-test.storymagic.co' },
];
